
import { Link } from 'react-router-dom';

export default function Footer() {
  const services = [
    { name: 'Körüklü Tente', slug: 'koruklu-tente' },
    { name: 'Mafsallı Tente', slug: 'mafsalli-tente' },
    { name: 'Otomatik Pergola', slug: 'otomatik-pergola' },
    { name: 'Bioklimatik Pergola', slug: 'bioklimatik-pergola' },
    { name: 'Zip Perde', slug: 'zip-perde' },
    { name: 'Şeffaf Stor', slug: 'seffaf-stor' },
    { name: 'Fransız Tente', slug: 'fransiz-tente' },
    { name: 'Kasetli Tente', slug: 'kasetli-tente' },
    { name: 'Karpuz Tente', slug: 'karpuz-tente' },
    { name: 'T Modül Tente', slug: 't-modul-tente' },
  ];

  return (
    <footer className="bg-primary text-white pt-16 pb-8">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12">
          <div>
            <h3 className="text-xl md:text-2xl font-bold mb-4 text-secondary">Bursa Tente</h3>
            <p className="text-gray-300 leading-relaxed text-sm">
              Bursa Tente olarak Bursa genelinde tente, pergola ve gölgelendirme sistemlerinde estetik,
              dayanıklı ve uzun ömürlü çözümler sunuyoruz. Körüklü tente, mafsallı tente, otomatik ve
              bioklimatik pergola sistemlerinde profesyonel montaj ve uygun fiyat garantisi sağlıyoruz.
            </p>
          </div>

          <div>
            <h4 className="text-base md:text-lg font-bold mb-4">Hızlı Menü</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  Anasayfa
                </Link>
              </li>
              <li>
                <Link
                  to="/hakkimizda"
                  className="text-gray-300 hover:text-secondary transition-colors text-sm cursor-pointer"
                >
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link
                  to="/hizmetler"
                  className="text-gray-300 hover:text-secondary transition-colors text-sm cursor-pointer"
                >
                  Hizmetler
                </Link>
              </li>
              <li>
                <Link
                  to="/yorumlar"
                  className="text-gray-300 hover:text-secondary transition-colors text-sm cursor-pointer"
                >
                  Müşteri Yorumları
                </Link>
              </li>
              <li>
                <Link
                  to="/iletisim"
                  className="text-gray-300 hover:text-secondary transition-colors text-sm cursor-pointer"
                >
                  İletişim
                </Link>
              </li>
              <li>
                <Link to="/kvkk" className="text-gray-300 hover:text-secondary transition-colors text-sm cursor-pointer">
                  KVKK Aydınlatma Metni
                </Link>
              </li>
              <li>
                <Link
                  to="/cerez-politikasi"
                  className="text-gray-300 hover:text-secondary transition-colors text-sm cursor-pointer"
                >
                  Çerez Politikası
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base md:text-lg font-bold mb-4">Hizmetler</h4>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.slug}>
                  <Link
                    to={`/hizmetler/${service.slug}`}
                    className="text-gray-300 hover:text-secondary transition-colors text-sm cursor-pointer"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base md:text-lg font-bold mb-4">İletişim</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-phone-fill text-secondary text-lg mt-0.5 flex-shrink-0"></i>
                <div>
                  <div className="text-sm text-gray-400 mb-1">Telefon</div>
                  <a
                    href="tel:+905421821925"
                    className="text-gray-300 hover:text-secondary transition-colors cursor-pointer text-sm"
                  >
                    +90 542 182 19 25
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-fill text-secondary text-lg mt-0.5 flex-shrink-0"></i>
                <div>
                  <div className="text-sm text-gray-400 mb-1">Adres</div>
                  <p className="text-gray-300 text-sm">Altıparmak Mahallesi, Haşim İşcan Caddesi No:24, Osmangazi / Bursa</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-global-fill text-secondary text-lg mt-0.5 flex-shrink-0"></i>
                <div>
                  <div className="text-sm text-gray-400 mb-1">Web</div>
                  <a
                    href="https://bursatente.com.tr"
                    className="text-gray-300 hover:text-secondary transition-colors cursor-pointer text-sm"
                  >
                    bursatente.com.tr
                  </a>
                </div>
              </li>
            </ul>

            <div className="flex gap-3 mt-6">
              <a
                href="https://wa.me/905421821925?text=Merhaba,%20tente%20ve%20pergola%20sistemleri%20hakkında%20bilgi%20almak%20istiyorum"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-secondary text-white px-4 py-2 rounded-full text-sm font-bold hover:bg-secondary/90 transition-all flex items-center gap-2 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-lg"></i>
                WhatsApp
              </a>
              <a
                href="tel:+905421821925"
                className="bg-white/10 text-white px-4 py-2 rounded-full text-sm font-bold hover:bg-white/20 transition-all flex items-center gap-2 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-lg"></i>
                Ara
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm text-center md:text-left">© 2026 Bursa Tente – Tüm Hakları Saklıdır.</p>
          <div className="flex flex-wrap justify-center md:justify-end gap-4 md:gap-6">
            <Link to="/kvkk" className="text-gray-400 hover:text-secondary transition-colors text-sm cursor-pointer">
              KVKK Aydınlatma Metni
            </Link>
            <Link
              to="/cerez-politikasi"
              className="text-gray-400 hover:text-secondary transition-colors text-sm cursor-pointer"
            >
              Çerez Politikası
            </Link>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-secondary transition-colors text-sm cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
